import { render } from "./muti-image-upload.vue?vue&type=template&id=49d1ab92"
import script from "./muti-image-upload.vue?vue&type=script&lang=js"
export * from "./muti-image-upload.vue?vue&type=script&lang=js"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__